<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/elJCyx/images/9781459249349_fmt.jpeg?1739570927062" alt="This image is the cover for the book Staking His Claim, Billionaires and Babies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Staking His Claim, Billionaires and Babies
      </h1>
      <p class="bookDescription body article font2">
        <p>When her flaky sister abruptly backs  out of their surrogacy agreement,  Ella McLeod is left with a newborn  she's in no position to care for. She'll have to give the baby up for adoption. Enter Yevgeny Volkovoyher sister's bossy billionaire brother-in-law.<br/><br/>Yevgeny won't let a Volkovoy be raised by strangers; he wants custody now. How can Ella be so cold as to deny him? Even worsewhy does this woman warm his steely heart? He may be staking his claim on the baby, but Ella may stake a counterclaim on his bachelorhood.<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tessa Radley
      </h2>
      
      <p class="authorDescription body article">Tessa Radley loves traveling, reading and watching the world around her. As a teen, Tessa wanted to be a foreign correspondent. But after completing a bachelor of arts degree and marrying her sweetheart, she ended up practicing as an attorney in a city firm. A break spent traveling through Australia re-awoke the yen to write. When she's not reading, traveling or writing, she's spending time with her husband, her two sons or her friends. Find out more at www.tessaradley.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fbe16ce8